import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, Element, scroller } from 'react-scroll';

import { slugify } from 'helpers';
import { HEADER_HEIGHT } from 'config';

import {
  scrollTabs,
  nav,
  navItem,
  activeNavItem,
} from './scss/ScrollTabs.module.scss';

const ScrollTabs = ({ tabs, defaultTab }) => {
  const scrollProps = {
    smooth: true,
    spy: true,
    activeClass: activeNavItem,
    offset: -80 - HEADER_HEIGHT,
  };

  useEffect(() => {
    if (defaultTab) {
      scroller.scrollTo(defaultTab, scrollProps);
    }
  }, []);

  return (
    <section className={scrollTabs}>
      <nav className={nav}>
        <div>
          {tabs.map(tab => (
            <Link
              to={slugify(tab.title)}
              key={tab.title}
              className={navItem}
              {...scrollProps}
            >
              {tab.title}
            </Link>
          ))}
        </div>
      </nav>
      <div>
        {tabs.map(tab => (
          <Element key={tab.title} name={slugify(tab.title)}>
            {tab.render()}
          </Element>
        ))}
      </div>
    </section>
  );
};

ScrollTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      render: PropTypes.func,
    })
  ),
  defaultTab: PropTypes.string,
};

ScrollTabs.defaultProps = {
  defaultTab: null,
};

export default ScrollTabs;
